import React from "react";
import { Container, Row } from "react-bootstrap";
import { GatsbyImage } from "gatsby-plugin-image";
import { PrismicRichText } from "@prismicio/react";
import Anchor from "../elements/Anchor";

import "../../styles/components/slices/calculate_loan.scss";

const CalculateLoan = ({ slice }) => {
  if (!slice) return null;

  return (
    <Container fluid className="calculate-loan">
      <Container className="max-container">
        <Row className="justify-content-center">
          <h2 className="title-45 text-center mb-4 col-11 col-md-8">
            {slice.primary.title1.text}
          </h2>
          {slice.primary.my_text && (
            <div className="text-center my-4 col-11 col-md-8">
              <PrismicRichText field={slice.primary.my_text.richText} />
            </div>
          )}
        </Row>

        {/* desktop image */}
        <Row className="position-relative d-none d-md-flex">
          <a
            href={slice.primary.button_link.url}
            className="book-now-btn text-center"
            target="_blank"
            rel="noreferrer"
          >
            <GatsbyImage
              image={slice.primary.image.gatsbyImageData}
              alt={slice.primary.image.alt || "calculate loan"}
            />
          </a>

          <div className="book-now-outline w-auto mona">
            <a
              href={slice.primary.button_link.url}
              className="book-now-btn text-center"
              target="_blank"
              rel="noreferrer"
            >
              {slice.primary.button_label}
            </a>
          </div>
        </Row>

        {/* mobile image */}
        <Row className="position-relative d-md-none">
          <GatsbyImage
            image={slice.primary.image_mobile1.gatsbyImageData}
            alt={slice.primary.image_mobile1.alt || "calculate loan"}
          />
          <div className="book-now-outline w-auto mona">
            <a
              href={slice.primary.button_link.url}
              className="book-now-btn text-center"
              target="_blank"
              rel="noreferrer"
            >
              {slice.primary.button_label}
            </a>
          </div>
        </Row>
      </Container>
    </Container>
  );
};

export default CalculateLoan;
